import React from 'react';
import './talent-css.css';
import {Follow} from 'react-twitter-widgets';


const Talent = () => (
    <div id="talent-div-1a">
        <div id="talent-div-2a">
            <div className="talent-div-3a">
                <h1 className="talent-text">Viral Digital Talent Team</h1>
            </div>
            <div className="talent-div-3a">
                <p className="talent-p-1a">
                    Viral recruits and is run by Twitter superstars.
                </p>
            </div>
            {/*<div className="talent-div-3a">*/}
                {/*<h3 className="talent-h3">*/}
                    {/*Twitter Stats*/}
                {/*</h3>*/}
            {/*</div>*/}
            {/*<div className="talent-div-3a">*/}
                {/*<p className="talent-p-1a">*/}
                    {/*4 billion impressions / month,*/}
                    {/*approx. 3% of network traffic on Twitter, worldwide.*/}
                {/*</p>*/}
            {/*</div>*/}
        </div>
        <div id="talent-div-2b">
            <div className="talent-div-3a">
                <h3 className="talent-h3">
                    Twitter Team
                </h3>
            </div>
            {/*<div className="talent-div-3a">*/}
                {/*<p className="talent-p-1a">*/}
                    {/*36 million followers and we're growing at a rate of 400,000 new followers / month.*/}
                {/*</p>*/}
            {/*</div>*/}
            <div id="talent-div-3b">
                <Follow username={'GirlfriendNotes'}/>
                <Follow username={'GirlPosts'}/>
                <Follow username={'FreddyAmazin'}/>
                <Follow username={'SoDamnTrue'}/>
                <Follow username={'LMAO'}/>
                <Follow username={'SoReIatable'}/>
                <Follow username={'FemaIes'}/>
                <Follow username={'Country_Voices'}/>
                <Follow username={'TumblrFunniez'}/>
                <Follow username={'GoogleFacts'}/>
                <Follow username={'RelatableQuote'}/>
            </div>
        </div>
    </div>
);

export default Talent


// WEBPACK FOOTER //
// ./src/components/core/talent/Talent.js